import React from 'react';
import { useTranslation } from 'react-i18next';

const OutboundRecordsPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">出库记录</h1>
        <p className="text-gray-600 mt-2">用于查看出库相关履约记录</p>
      </div>

      <div className="bg-white rounded-lg shadow p-6">
        <div className="text-gray-700">
          {t('common.comingSoon', '功能建设中，后续将补充具体业务逻辑。')}
        </div>
      </div>
    </div>
  );
};

export default OutboundRecordsPage;
